import { render, staticRenderFns } from "./Medical.vue?vue&type=template&id=f67f1f10&scoped=true"
import script from "./Medical.vue?vue&type=script&lang=js"
export * from "./Medical.vue?vue&type=script&lang=js"
import style0 from "./Medical.vue?vue&type=style&index=0&id=f67f1f10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f67f1f10",
  null
  
)

export default component.exports